<template>
  <div class="nbm-overlay" @mousedown.self="close">
    <div class="nbm">
      <h2 class="nbm__title">{{ titleCase((options.Lang && options.Lang.neuesBranding) || 'neues Branding') }}</h2>

      <CustomInput
          :label="titleCase((options.Lang && options.Lang.Bezeichnung) || 'Bezeichnung')"
          v-model="name"
          @keyup.enter="create" />

      <div class="nbm__actions">
        <CustomButton variant="secondary" :label="(options.Lang && options.Lang.Abbrechen) || 'Abbrechen'" @click="close" />
        <CustomButton variant="primary" :label="(options.Lang && options.Lang.Speichern) || 'Speichern'" :disabled="saving || !name.trim()" @click="create" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from '../parts/CustomInput.vue';
import CustomButton from '../parts/CustomButton.vue';

/**
 * Lightweight "create branding" modal: asks only for the name (the sole meaningful
 * required field), creates the branding, and emits `created` with the new id so the
 * caller can open the full editor. Everything else is edited afterwards.
 */
export default {
  name: 'NewBrandingModal',
  components: { CustomInput, CustomButton },
  props: {
    options: { type: Object, required: true }
  },
  data() {
    return { name: '', saving: false };
  },
  // Vue 2 has no <teleport>: move the modal to <body> so its fixed overlay can't be
  // trapped behind the side drawer or clipped by a parent stacking context.
  mounted() {
    document.body.appendChild(this.$el);
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
  },
  methods: {
    titleCase(str) {
      if (!str) return '';
      return String(str).replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1));
    },
    close() {
      if (this.saving) return;
      this.$emit('close');
    },
    create() {
      const self = this;
      const name = this.name.trim();
      if (!name) return;
      this.saving = true;
      const data = {
        adresse: name,         // branding display name
        bezeichnung: '',       // company (filled later)
        tripLang: 'en',
        sprache: 'en',
        user: this.options.user.id
      };
      self.doPost({ data }, 'newBranding', function (res) {
        self.saving = false;
        if (!res || !res.data || res.data.status === 'error') {
          const msg = (res && res.msg) ? res.msg : 'error_contact_support';
          if (self.help && self.help.log) self.help.log(self.$t(msg), false, true);
          else console.error('newBranding failed', res);
          return;
        }
        const newId = res.data.data && res.data.data.insertId;
        self.$emit('created', { id: newId, name });
      });
    }
  }
};
</script>

<style scoped>
.nbm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  /* Above the side drawer (z-index: 111111111) so the backdrop covers it too. */
  z-index: 999999999;
}
.nbm {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  width: 90%;
  max-width: 440px;
  padding: 1.75rem 2rem;
  box-sizing: border-box;
}
.nbm__title { font-size: 1.4rem; font-weight: 700; color: #2c2c2c; margin: 0 0 0.4rem; }
.nbm__hint { font-size: 0.85rem; color: #888; margin: 0 0 1.25rem; line-height: 1.4; }
.nbm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
}
</style>
